import styled from 'styled-components';

const IconPlaceholder = styled.div `
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export { IconPlaceholder };
